var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormGridPanel',{ref:"formGridPanel",attrs:{"tableColumns":_vm.columns,"queryForm":_vm.formConfig},on:{"onSubmitQuery":_vm.onSubmitQuery,"onRowCellClick":_vm.onRowCellClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }